import { Dialog } from '@base-ui/react/dialog'
import type { ReactNode } from 'react'

import s from './FullScreenDialog.module.css'

/**
 * FullScreenDialog — une tâche qui demande tout l'écran : la fenêtre entière, coquille comprise,
 * sans voile ni carte. Le contenu porte sa propre barre (`Page`, `PageHeader`) et ses gestes.
 *
 * Née pour la correction du schéma au bureau (#671, Back Office 3.8b) : dans l'onglet, le plan
 * restait trop petit pour être corrigé.
 *
 * Le comportement vient de la primitive `Dialog` de Base UI (règle 3) : piège de focus, reste de la
 * page inerte, verrou de défilement, rôles ARIA.
 *
 * ⚠️ **Aucune fermeture n'est exposée, et c'est voulu** : seuls les gestes de l'écran, qui
 * changent `open`, la referment. Échap reste sans effet — ce qu'elle porte est une saisie en
 * cours, et une touche pressée pour sortir d'un tracé la jetterait en entier.
 */
export interface FullScreenDialogProps {
  open: boolean
  /** Le nom de la couche, annoncé à l'ouverture — d'ordinaire le titre de sa barre. */
  label: string
  children?: ReactNode
}

export function FullScreenDialog({ open, label, children }: FullScreenDialogProps) {
  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Popup className={s.popup} aria-label={label}>
          {children}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
